import axios from 'axios'
import {
    Message
} from 'element-ui'
// 创建axios实例
const service = axios.create({
    // baseURL: "http://123.207.174.253:808/api", // api的base_url    
    // baseURL: "http://localhost:52688/api",
    baseURL: "http://pt.zhzymedia.cn/api",
	// baseURL: "http://47.115.92.84:808/api",
    // baseURL: "http://47.115.92.84:808/api",
    timeout: 3000000 // 请求超时时间
})

const redirect_uri = "http://pt.zhzymedia.cn/";

// request拦截器
service.interceptors.request.use(config => {
    let username = localStorage.getItem("username") || null;
    let token = localStorage.getItem("token") || null;
    if (!token || !username) {
        location.href = redirect_uri;
        return Promise.reject();
    }
    config.headers["username"] = username;
    config.headers["token"] = token;
    return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    return Promise.reject(error);
})
// respone拦截器
service.interceptors.response.use(
    res => {
        let result = res.data;
        if (result) {
            if (result.code == 0) {
                return result;
            } else if (result.code == 400 ) {
                //token失效，跳转登录页面
                localStorage.clear();
                Message({
                    message: result.message,
                    type: 'error',
                    duration: 5 * 1000
                });
                location.href = redirect_uri;
                return Promise.reject();
            } else if ( result.code == 403) {
                //token失效，跳转登录页面
                localStorage.clear();
                location.href = redirect_uri;
                return Promise.reject();
            } else {
                Message({
                    message: result.message,
                    type: 'error',
                    duration: 5 * 1000
                })

                if (result.message == "用户余额不足，请前往充值") {
                    setTimeout(function () {
                        let newpage = "http://pt.zhzymedia.cn/#/balanceRecharge"
                        // let newpage = "http://localhost:8081/#/balanceRecharge"
                        window.open(newpage, "_blank");
                    }, 1000)
                }


            }
        }
        return Promise.reject(result);
    },
    error => {
        console.log('err' + error) // for debug
        Message({
            message: "请求错误，请重新登陆",
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    })
/**
 * 封装并导出get方法、post方法。
 */
export default {
    get(url, params) {
        return service.get(url, params)
    },

    post(url, params) {
        return service.post(url, params)
    },
}